import { Helmet } from 'react-helmet-async';

const RecruitmentHelmet = ({ job }) => (
  <Helmet key={'tuyen-dung'}>
    <title>{'Tuyển dụng | Thành Đồng Group'}</title>
    <meta
      name="description"
      content={
        'Công ty Thành Đồng đang tuyển dụng các vị trí nhân viên vệ sinh, kỹ thuật viên, chăm sóc khách hàng tại Cần Thơ.'
      }
    />
    <meta name="robots" content="index, follow" />
    <meta
      name="keywords"
      content="tuyển dụng, việc làm, thành đồng, cơ hội nghề nghiệp, vệ sinh công nghiệp, vệ sinh cần thơ, việc làm cần thơ"
    />

    <meta property="og:type" content="article" />
    <meta property="og:title" content={'Tuyển dụng tại Thành Đồng'} />
    <meta
      property="og:description"
      content={
        'Xem chi tiết các vị trí tuyển dụng tại Công ty TNHH XD TMDV Thành Đồng.'
      }
    />
    <meta property="og:image" content={'https://thanhdongct.com/images/logo_thanh_dong.png'} />
    <meta property="og:url" content={window.location.href} />
    <link rel="canonical" href={window.location.href} />
  </Helmet>
);

export default RecruitmentHelmet;
